import DOMPurify from 'dompurify';

function applyExternalLinkTargets(html) {
    if (!html || typeof document === 'undefined') {
        return html;
    }

    const wrapper = document.createElement('div');
    wrapper.innerHTML = html;

    wrapper.querySelectorAll('a[href]').forEach((anchor) => {
        if (!anchor.getAttribute('target')) {
            anchor.setAttribute('target', '_blank');
        }

        const rel = (anchor.getAttribute('rel') || '').trim();
        const relParts = new Set(rel ? rel.split(/\s+/) : []);

        relParts.add('noopener');
        relParts.add('noreferrer');
        anchor.setAttribute('rel', Array.from(relParts).join(' '));
    });

    return wrapper.innerHTML;
}

export function safeRichTextHtml(input) {
    const raw = (input ?? '').toString();
    if (!raw) return '';

    // If content looks like HTML, sanitize and render.
    const looksLikeHtml = /<\/?[a-z][\s\S]*>/i.test(raw);
    if (looksLikeHtml) {
        const sanitized = DOMPurify.sanitize(raw, {
            USE_PROFILES: { html: true },
            ALLOWED_TAGS: [
                'p', 'br',
                'ul', 'ol', 'li',
                'strong', 'b', 'em', 'i', 'u',
                'h1', 'h2', 'h3', 'h4',
                'a',
            ],
            ALLOWED_ATTR: ['href', 'target', 'rel'],
        });

        return applyExternalLinkTargets(sanitized);
    }

    // Plain text: preserve newlines as <br/>
    const escaped = raw
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');
    return escaped.replace(/\r?\n/g, '<br/>');
}
